import { HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { ReportEvaluationDisciplineFiltersDTO, ReportEvaluationPracticeFiltersDTO, ReportEvaluationProjectFiltersDTO, ReportEvaluationResourceFiltersDTO, ReportEvaluationOpenProjectFiltersDTO, ReportEvaluationResourcesByDisciplineFiltersDTO } from "../models/export-report.model";
import { Resource } from "../models/personnel.model";
import { ProjectData, ProjectEvaluationData } from "../models/project-evaluation.model";

export abstract class ProjectEvaluationRepository {
  /**
   * Carica i dati di valutazione del progetto per un determinato agreement
   * @param agreementId ID dell'agreement
   * @returns Observable con i dati di valutazione del progetto
   */
  abstract getProjectEvaluation(agreementId: number): Observable<ProjectData>;

  /**
   * Salva i dati di valutazione aggiornati
   * @param evaluationData Dati di valutazione da salvare
   * @returns Observable che completa quando i dati sono salvati
   */
  abstract saveProjectEvaluation(evaluationData: ProjectEvaluationData): Observable<ProjectData>;

  /**
   * Chiude le valutazioni del progetto per impedire ulteriori modifiche
   * @param agreementId ID dell'agreement
   * @returns Observable che completa quando le valutazioni sono chiuse
   */
  abstract closeProjectEvaluation(agreementId: number): Observable<boolean>;
  
  /**
   * Ottiene la lista delle risorse con parametro di ricerca opzionale
   * @param search Parametro di ricerca opzionale per filtrare le risorse per nome, cognome o email
   * @returns Observable con l'array delle risorse filtrate
   */
  abstract searchResources(search?: string): Observable<Resource[]>;

  /**
   * Esporta il report delle discipline tramite chiamata POST al server
   * @param filters Filtri per il report delle discipline (disciplina e range di date)
   * @returns Observable che completa quando il report è stato richiesto al server
   */
  abstract exportDisciplineReport(filters: ReportEvaluationDisciplineFiltersDTO): Observable<HttpResponse<Blob>>;

  /**
   * Esporta il report delle practice tramite chiamata POST al server
   * @param filters Filtri per il report delle practice (practice e range di date)
   * @returns Observable che completa quando il report è stato richiesto al server
   */
  abstract exportPracticeReport(filters: ReportEvaluationPracticeFiltersDTO): Observable<HttpResponse<Blob>>;

  /**
   * Esporta il report delle risorse tramite chiamata POST al server
   * @param filters Filtri per il report delle risorse (risorsa e range di date)
   * @returns Observable che completa quando il report è stato richiesto al server
   */
  abstract exportResourceReport(filters: ReportEvaluationResourceFiltersDTO): Observable<HttpResponse<Blob>>;

  /**
   * Esporta il report del progetto tramite chiamata POST al server
   * @param filters Filtri per il report del progetto (disciplina, practice, flag di valutazione e range di date)
   * @returns Observable che completa quando il report è stato richiesto al server
   */
  abstract exportProjectReport(filters: ReportEvaluationProjectFiltersDTO): Observable<HttpResponse<Blob>>;

  /**
   * Esporta il report dei progetti aperti tramite chiamata POST al server
   * @param filters Filtri per il report dei progetti aperti (disciplina, practice, flag di valutazione e range di date)
   * @returns Observable che completa quando il report è stato richiesto al server
   */
  abstract exportOpenProjectReport(filters: ReportEvaluationOpenProjectFiltersDTO): Observable<HttpResponse<Blob>>;

  /**
   * Esporta il report delle risorse raggruppate per disciplina tramite chiamata POST al server
   * @param filters Filtri per il report (disciplina e range di date)
   * @returns Observable che completa quando il report è stato richiesto al server
   */
  abstract exportResourcesByDisciplineReport(filters: ReportEvaluationResourcesByDisciplineFiltersDTO): Observable<HttpResponse<Blob>>;
}
